var DEFAULT_LOCALE = 'en';
var DEFAULT_EMAIL_HOST = 'support.gandi.net';
function mapLocaleToEmail(locale) {
  return {
    en: 'en',
    de: 'en',
    fr: 'fr',
    es: 'es',
    ja: 'ja',
    'zh-hant': 'zh',
    'zh-hans': 'zh'
  }[locale] || DEFAULT_LOCALE;
}
function getSupportEmail() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_LOCALE;
  return "support-".concat(mapLocaleToEmail(locale), "@").concat(DEFAULT_EMAIL_HOST);
}
export { getSupportEmail };